import React, { useContext, useRef } from "react";
import {
  MajorOutageCardStyle,
  StyledButton,
  StyledSlider,
} from "./majorOutageCard.style";
import { Box } from "@mui/material";
import EyeBrow from "component/commonComponents/eyeBrow/eyeBrow";
import { TruncatedText } from "component/MarketPlace/Typography/Typography.style";
import { ThemeContext } from "styled-components";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Slider, Settings } from "component/commonComponents/Slider";

export interface IMajorOutageCardProps {
  eyeBrowText: string;
  handleClickViewDetail: (e: MouseEvent, kbNumber: string) => void;
  outageIcon: string;
  majorOutageList: any;
  showOutageEyebrow: boolean;
}

const MajorOutageCard = (props: IMajorOutageCardProps) => {
  const { eyeBrowText, handleClickViewDetail, outageIcon, majorOutageList, showOutageEyebrow } = props;
  const theme = useContext(ThemeContext);
  const ref = useRef<typeof Slider>(null);

  const clickNext = () => {
    return ref.current?.slickNext();
  };

  const clickPrevious = () => {
    return ref.current?.slickPrev();
  };

  const defaultSliderSettings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    arrows: false,
    appendDots: (dots: any) => (
      <ul>
        {majorOutageList?.length > 1 && (
          <>
            <StyledButton onClick={clickPrevious}>
              <ChevronLeft />
            </StyledButton>
            {dots}
            <StyledButton onClick={clickNext}>
              <ChevronRight />
            </StyledButton>
          </>
        )}
      </ul>
    ),
  };

  return (
    <MajorOutageCardStyle isShowSlideBtn={majorOutageList?.length > 1} showOutageEyebrow={showOutageEyebrow}>
      <StyledSlider {...defaultSliderSettings} ref={ref}>
        {majorOutageList?.map((item: any) => (
          <Box sx={{cursor: "pointer"}} display={showOutageEyebrow ? "inline-block" : "flex !important"} flex="1" alignItems="center" padding={showOutageEyebrow ? "15px 0 0 15px" : "0 0 0 15px"} height="100%" key={item?.id} onClick={(e: any) => handleClickViewDetail(e, item?.number)}>
            {showOutageEyebrow && (
              <Box>
                <EyeBrow
                  text={eyeBrowText}
                  uppercase={true}
                  backgroundColor={
                    theme.uptimeColors.newsKnowledgeColors?.eyeBrow?.majorOutages?.background
                  }
                  color={theme.uptimeColors.newsKnowledgeColors?.eyeBrow?.majorOutages?.color}
                  width="64px"
                  height="21px"
                />
              </Box>
            )}
            <Box display="flex" alignItems="center" width="100%" padding="10px 10px 10px 15px" maxHeight="75px">
              <img src={outageIcon} width="30px" alt="major-outage-icon" />
              <Box width="100%" paddingLeft="25px" paddingRight="10px">
                <TruncatedText
                  lineHeight="20px"
                  maxlines={2}
                  fontSize={
                    theme.uptimeDynamicFontSize?.majorOutageCard?.fontSize
                  }
                  fontWeight={
                    theme.uptimeDynamicFontSize?.majorOutageCard?.fontWeight
                  }
                  color={theme.uptimeColors?.generalColors?.majorOutageCard}
                  width="fit-content"
                  maxWidth="90%"
                  sx={{wordWrap: "break-word" ,"&:hover": {textDecoration: "underline"}}}
                >
                  {item?.name}
                </TruncatedText>
              </Box>
            </Box>
          </Box>
        ))}
      </StyledSlider>
    </MajorOutageCardStyle>
  );
};

export default MajorOutageCard;